export default "__VITE_ASSET__656f43ca__"